// extracted by mini-css-extract-plugin
export default {"mentions":"XhiiBuvnHjnFNs194rAc","p":"Sj4JdGM9jQ83xiPYzGPr"};